import { render, staticRenderFns } from "./Detail-Asset-Stock.vue?vue&type=template&id=f284955c&"
import script from "./Detail-Asset-Stock.vue?vue&type=script&lang=js&"
export * from "./Detail-Asset-Stock.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Asset-Stock.vue?vue&type=style&index=0&id=f284955c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports